import {
  Divider,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
} from '@chakra-ui/react'
import { FC } from 'react'
import { useMobileBackButton, useModalBodyClass } from '../../hooks/useMobileBackButton'
import { BookDemoForm } from './BookDemoForm'

export const BookDemo: FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()

  useMobileBackButton(
    isOpen,
    () => {
      onClose()
    },
    () => {
      window.history.back()
    },
  )

  useModalBodyClass(isOpen)

  return (
    <>
      <div
        onClick={onOpen}
        className="w-full sm:w-[15%] text-white text-[0.875rem] flex justify-center cursor-pointer"
      >
        Want to request a Demo?
      </div>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size="2xl"
        isCentered
        trapFocus={false}
        lockFocusAcrossFrames={false}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader m={5} mb={0} pb={0}>
            <p className="font-bold text-tdplindigo text-[2rem]">Request a Demo</p>
          </ModalHeader>
          <ModalBody>
            <Divider orientation="horizontal" m={0} mb={5} />
            <BookDemoForm onCloseModal={onClose} />
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  )
}
